// import * as Sentry from '@sentry/react';

export const captureException = ({ type, message, withScope }) => {
  const exception = new Error(message);

  exception.name = type;

  console.error(message);
  // Sentry.withScope(scope => {
  //   scope.setTag(type, message);
  //   scope.setExtra('Url', window.location.href);
  //   scope.setExtra('Document referrer', document.referrer);
  //
  //   if (typeof withScope === 'function') {
  //     withScope(scope);
  //   }
  //
  //   Sentry.captureException(exception);
  // });
};
